import React from 'react';
import { motion } from 'framer-motion';
import people from "../assets/images/pp.png";

export default function TrustedFinancial() {
    const text = "Fastest Exchange is the universal way for you to manage money internationally. It's made for the world. And it's built to save your money and time, so you can do more of the things you love.";

    // Split the paragraph into words
    const words = text.split(" ");

    return (
        <>
            <section className='trusted_financial rounded-lg'>
                <motion.div
                    className='max-w-90vw h-fit px-[4%] grid lg:grid-cols-2 sm:grid-cols-1 gap-8 rounded-lg p-8 bg-gradient-to-r from-black to-[#06069a] opacity-70'
                    initial={{ opacity: 0 }}
                    whileInView={{ opacity: 0.8 }}
                    transition={{ duration: 1.2, ease: 'easeOut' }}
                >
                    {/* Left Section with Animations */}
                    <div className="px-14">
                        {/* Big text slide-in */}
                        <motion.h1
                            className='text-white text-[2rem] font-[800] leading-[1.4] py-6'
                            initial={{ x: -100, opacity: 0 }}
                            whileInView={{ x: 0, opacity: 1 }}
                            transition={{ type: 'spring', stiffness: 100, damping: 25 }}
                        >
                            Trusted <span className='text-[#D71E7E]'>Financial Partner</span> for the Workforce
                        </motion.h1>

                        {/* Small text - animate by words */}
                        <motion.p
                            className='text-[1rem] text-[white] pt-4'
                            initial={{ opacity: 0 }}
                            animate={{ opacity: 1 }}
                            whileInView={{ opacity: 1 }}
                            viewport={{ once: true}}
                            transition={{
                                delay: 0.5,
                                duration: 2,
                                staggerChildren: 0.2 // Delay between each word animation
                            }}
                        >
                            {words.map((word, index) => (
                                <motion.span
                                    key={index}
                                    initial={{ opacity: 0 }}
                                    animate={{ opacity: 1 }}
                                    transition={{
                                        delay: index * 0.2, // Delay each word animation sequentially
                                        duration: 0.5
                                    }}
                                >
                                    {word}{" "}
                                </motion.span>
                            ))}
                        </motion.p>

                        {/* Button Fade-in with Hover effect */}
                        <motion.button
                            className='my-10 px-8 py-[8px] bg-gradient-to-r from-black to-[#06069a] opacity-70 text-[.9rem] text-[#2AD5FF] border border-1 border-[var(--primary-color)] rounded-md hover:bg-[#05295c] transition duration-200'
                            initial={{ opacity: 0 }}
                            whileInView={{ opacity: 1 }}
                            transition={{ duration: 1, delay: 1 }}
                            whileHover={{ scale: 1.1 }}
                        >
                            Get Started
                        </motion.button>
                    </div>

                    {/* Right Section - Image zoom-in animation */}
                    <motion.div
                        className="hidden md:block"
                        initial={{ opacity: 0, scale: 0.8 }}
                        whileInView={{ opacity: 1, scale: 1 }}
                        transition={{ duration: 0.8 }}
                    >
                        <img src={people} alt="people" className='w-[350px]' />
                    </motion.div>
                </motion.div>
            </section>
        </>
    );
}
